<template>
  <div>
    Header Default
    <ul>
      <li>
        <router-link :to="{ name: 'homePage' }">Home</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'pricingPage' }">Pricing</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'contactPage' }">Contact us</router-link>
      </li>
      <li>
        <router-link :to="{ name: 'loginPage' }">
          Login (hide when logged)
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'DashboardPage' }">
          Dashboard (Show When logged)
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "HeaderDefault",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL
    };
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/style/css/generic-variables.scss";
</style>
